import { useEffect, useState } from "react";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { UNWANTED_BRAKING_REPORT } from "../interfaces/dashboard";
import { UNWANTED_BRAKING_REPORT_DATA } from "../constants/data.cnst";
import Reports from "../components/reports";

export default function UnwantedBraking() {

    const undesirableBrakingReportTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.UNWANTED_BRAKING_REPORT;

    const [undesirableBrakingReportTableData, setUnwantedBrakingReportTableData] = useState<UNWANTED_BRAKING_REPORT[]>([]);

    useEffect(() => {
        setUnwantedBrakingReportTableData(UNWANTED_BRAKING_REPORT_DATA)
    }, []);

    return (
        <Reports
        reportType="UNWANTED_BRAKING"
        tableColumns={undesirableBrakingReportTableColumns}
        tableData={undesirableBrakingReportTableData} />   
    );
}